import { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { cn } from '../lib/utils'
import { useHouseholds } from '../hooks/useHouseholds'

const ChevronIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="6 9 12 15 18 9" />
  </svg>
)

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
)

export const HouseholdSwitcher = () => {
  const { households, currentHousehold, switchHousehold } = useHouseholds()
  const [open, setOpen] = useState(false)
  const ref    = useRef(null)
  const navigate = useNavigate()

  // Close when clicking outside
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  if (!currentHousehold) return null

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        className={cn(
          'flex items-center gap-1.5 px-3 py-1.5 rounded-base text-sm font-medium',
          'text-text-primary hover:bg-primary-light transition-colors',
          open && 'bg-primary-light'
        )}
      >
        <span className="max-w-[140px] truncate">{currentHousehold.name}</span>
        <ChevronIcon />
      </button>

      {open && (
        <div className="absolute left-0 top-full mt-1 w-56 bg-surface rounded-base shadow-card border border-border z-50 overflow-hidden">
          <div className="px-3 py-2 border-b border-border">
            <p className="text-xs font-medium text-text-muted uppercase tracking-wide">Your households</p>
          </div>

          <div className="py-1">
            {households.map((h) => (
              <button
                key={h.id}
                onClick={() => { switchHousehold(h.id); setOpen(false) }}
                className={cn(
                  'w-full flex items-center justify-between px-4 py-2.5 text-sm text-left',
                  'hover:bg-background transition-colors',
                  h.id === currentHousehold.id ? 'text-primary font-medium' : 'text-text-primary'
                )}
              >
                <span className="truncate">{h.name}</span>
                {h.id === currentHousehold.id && (
                  <span className="text-primary flex-shrink-0"><CheckIcon /></span>
                )}
              </button>
            ))}
          </div>

          <div className="border-t border-border py-1">
            <button
              onClick={() => { navigate('/onboarding?new=1'); setOpen(false) }}
              className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-text-secondary hover:bg-background transition-colors"
            >
              <PlusIcon />
              <span>Create new household</span>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
